module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "topbar"
  }, [_c('spaceselect')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f49d903!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/Topbar.vue
// module id = 512
// module chunks = 22